var _linearGradient, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff7e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f33f5e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 3.782a.995.995 0 1 0 0 1.99.995.995 0 0 0 0-1.99zm3.452 0a.995.995 0 1 0 0 1.99.995.995 0 0 0 0-1.99zm3.451 0a.995.995 0 1 0 0 1.99.995.995 0 0 0 0-1.99z",
    fill: "url(#gradient)",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 1H4C2.35 1 1 2.35 1 4v24c0 1.65 1.35 3 3 3h24c1.65 0 3-1.35 3-3V4c0-1.65-1.35-3-3-3zm-7.52 20.11c.39.39.39 1.02 0 1.41a.992.992 0 0 1-1.42 0L18 21.46l-1.06 1.06c-.2.2-.46.3-.71.3-.26 0-.51-.1-.71-.3a.996.996 0 0 1 0-1.41l1.07-1.06-1.07-1.07a.996.996 0 0 1 0-1.41c.39-.39 1.02-.39 1.42 0L18 18.63l1.06-1.06c.39-.39 1.03-.39 1.42 0 .39.39.39 1.02 0 1.41l-1.07 1.07 1.07 1.06zm5.06-5.69H12.65l-2.76 8.03a.98.98 0 0 1-.91.67h-.04a.99.99 0 0 1-.91-.6l-2.49-5.77c-.22-.51.01-1.1.52-1.32.51-.21 1.09.02 1.31.53l1.47 3.4 2.15-6.26c.14-.4.52-.68.95-.68h13.6c.56 0 1 .45 1 1 0 .56-.44 1-1 1zM29 6.55H3V4c0-.55.45-1 1-1h24c.55 0 1 .45 1 1v2.55z",
    fill: "url(#gradient)",
    className: "color000 svgShape"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOt);
export default __webpack_public_path__ + "static/media/ot.a8cc57851d8a1d8c9fd0a7ab0c375728.svg";
export { ForwardRef as ReactComponent };